import shared_messages_en from '../../../../../_themes/hancock-whitney-theme/src/shared/js/i18n/en/messages_en.mjs';
import consumer_messages_en from '../../../../../_themes/hancock-whitney-theme/src/shared/js/i18n/en/consumer_messages_en.mjs';
import messages_en from './en/messages_en.mjs';

export default {
  'en': {
    ...shared_messages_en,
    ...consumer_messages_en,
    ...messages_en
  }
};
